import { render } from "./MaterialsEditorView.vue?vue&type=template&id=02f000da"
import script from "./MaterialsEditorView.vue?vue&type=script&lang=js"
export * from "./MaterialsEditorView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__